import SwiperSlider from "../components/abstract/SwiperSlider";
import $ from 'jquery';

export default class Slider3elementi extends SwiperSlider {
  constructor(element, context) {
    super(element, context);

    this.options = {
        spaceBetween: 20,
        allowTouchMove: true,
        centeredSlides: true,
        slidesPerView: 1.3,
        loop: false,
        breakpoints: {
         768: {
          centeredSlides: false,
           slidesPerView: 2.3,
           spaceBetween: 40,
         },

         1024: {
          centeredSlides: false,
          slidesPerView: 3.3,
           spaceBetween: 60,
         }
        }
    };

    $(() => {
      this.init();
    });
  }
}
